var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddQrcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-addQrcode"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-addQrcode",
    clipPath: "url(#clip-icon-addQrcode)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_8",
    "data-name": "\\u5716\\u5C64 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M480.061,113H120.61a8.673,8.673,0,0,0-8.673,8.673V464.585a8.673,8.673,0,0,0,8.673,8.673H480.061a8.673,8.673,0,0,0,8.673-8.673V121.673A8.673,8.673,0,0,0,480.061,113ZM432.889,408.741a8.672,8.672,0,0,1-8.672,8.672H176.455a8.672,8.672,0,0,1-8.673-8.672V177.517a8.673,8.673,0,0,1,8.673-8.672H424.217a8.673,8.673,0,0,1,8.672,8.672Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 102.99,
    height: 102.99,
    rx: 8.633,
    transform: "translate(249.504 244.106)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M906.039,556.484H548.315a8.631,8.631,0,0,0-8.631,8.631V906.38a8.631,8.631,0,0,0,8.631,8.631H906.039a8.631,8.631,0,0,0,8.631-8.631V565.115A8.631,8.631,0,0,0,906.039,556.484ZM859.094,850.8a8.632,8.632,0,0,1-8.632,8.631H603.891a8.631,8.631,0,0,1-8.631-8.631V620.691a8.631,8.631,0,0,1,8.631-8.631H850.462a8.632,8.632,0,0,1,8.632,8.631Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 102.495,
    height: 102.495,
    rx: 8.591,
    transform: "translate(675.929 686.96)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 60.418,
    height: 60.418,
    rx: 8.591,
    transform: "translate(427.126 854.593)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 60.418,
    height: 60.418,
    rx: 8.591,
    transform: "translate(232.233 854.593)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M232.233,746.78a8.632,8.632,0,0,0,8.631,8.632H478.913a8.632,8.632,0,0,0,8.631-8.632V565.115a8.631,8.631,0,0,0-8.631-8.631H435.464a8.631,8.631,0,0,0-8.631,8.631v43.156A8.631,8.631,0,0,1,418.2,616.9H375.046a8.631,8.631,0,0,1-8.631-8.631V565.115a8.631,8.631,0,0,0-8.631-8.631H120.028a8.631,8.631,0,0,0-8.631,8.631V906.38a8.631,8.631,0,0,0,8.631,8.631h43.156a8.631,8.631,0,0,0,8.631-8.631V703.548a8.631,8.631,0,0,1,8.631-8.631H223.6a8.631,8.631,0,0,1,8.631,8.631Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M734.541,113A180.129,180.129,0,1,0,914.67,293.129,180.128,180.128,0,0,0,734.541,113Zm100.1,201.564H755.734v78.667a21.121,21.121,0,0,1-42.243,0V314.564H634.438a21.121,21.121,0,0,1,0-42.243h79.053V193.027a21.121,21.121,0,0,1,42.243,0v79.294h78.909a21.121,21.121,0,0,1,0,42.243Z",
    fill: "#0d7fc2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddQrcode);
export default __webpack_public_path__ + "static/media/icon-addQrcode.9cffd85c42db94a1834ba8fb77eca893.svg";
export { ForwardRef as ReactComponent };